import React from "react";
import "./Hero.css";

function Hero() {
    return (
        <section className="modern-hero-section">
            <div className="modern-hero-glow"></div>
            
            <div className="container modern-hero-content">
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-xl-8">
                        <div className="modern-hero-card text-center wow fadeInUp delay-0-2s">
                            <span className="modern-hero-subtitle">
                                Empower Your Business
                            </span>
                            <h1 className="modern-hero-title">
                                Excellent IT services for your <span>success</span>
                            </h1>
                            <p className="text-white mb-0" style={{fontSize: '18px', opacity: 0.8}}>
                                We deliver cutting-edge software solutions and strategic consulting to accelerate your digital transformation.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Hero;
